const filmLocationRouter = {
  route: null,
  name: null,
  title: '片场服务',
  type: 'folder', // 类型: folder, tab, view
  icon: 'iconfont el-icon-postcard',
  filePath: 'view/film_location/', // 文件路径
  order: 35,
  inNav: true,
  permission: ['片场服务'],
  children: [
    {
      title: '片场列表',
      type: 'view',
      name: 'filmLocationList',
      route: '/filmLocation/list',
      filePath: 'view/film_location/list.vue',
      inNav: true,
      icon: 'iconfont el-icon-notebook-2',
      permission: ['片场列表'],
    },
    {
      title: '添加片场',
      type: 'view',
      name: 'addFilmLocation',
      route: '/filmLocation/add',
      filePath: 'view/film_location/create.vue',
      inNav: true,
      icon: 'iconfont el-icon-document-add',
      permission: ['添加片场'],
    },
  ],
}

export default filmLocationRouter
